import { Typography } from '@mui/material';
import { Button } from '@rcg/ui-components';
import styled from 'styled-components';
import colors from 'styles/colors';
import media from 'styles/media';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';

export const TitleRow = styled.div`
	display: inline-flex;
	justify-content: space-between;
	margin-bottom: 0px;
	align-items: center;
`;

export const ResultsHeaderWrap = styled.div`
	width: 100%;
	max-width: 1220px;
	min-width: 300px;
	position: relative;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;

	&.compare {
		flex-direction: column;
		position: sticky;
		top: 0;

		${TitleRow} {
			align-self: flex-start;
		}
	}

	@media (max-width: ${sizes.media.tabletMinWidth}px) {
		flex-direction: column;
		align-items: flex-start;
	}
`;

export const DropdownsRow = styled.div`
  display: inline-flex;
  align-items: baseline;
  flex-direction: row;
  margin: 15px 0;

  @media (max-width: ${sizes.media.smallMaxWidth}px) {
    width: 100%;
    justify-content: space-between;
  	flex-direction: column;
    align-items: baseline;
  }

  ${media.small`
    #results-dropdown-sort{
      display: flex;
      align-items: baseline;
      ${({ theme }) =>
				({
					[BrandCode.RoyalCaribbean]: `
          margin-block: 4px;
        `,
				})[theme.brandCode]}
    `}
    }
`;

export const LabeledDropdown = styled.div`
	display: inline-flex;
	align-items: baseline;

	@media (min-width: ${sizes.media.smallMaxWidth + 1}px) {
		&:not(:last-child) {
			margin-right: 20px;
			${media.large`
			margin-right: 30px;
		`}
		}
	}

	@media (max-width: ${sizes.media.smallMaxWidth}px) {
		width: 100%;
		justify-content: space-between;
		align-items: flex-end;
		& button {
			padding: 3px 0px;
		}
	}
`;

export const Label = styled(Typography)`
	color: ${colors.rccl.lavelResultsHeader};
	min-width: max-content;
	margin-right: 6px !important;
	&& span {
		${({ styles }) => styles}
		${({ theme }) =>
			({
				[BrandCode.RoyalCaribbean]: `
        font-family: ${theme.typography.fontFamilySemiBold};
        `,
			})[theme.brandCode]}
	}
`;

export const SectionTitle = styled(Typography)`
	color: ${({ palette }) => palette.secondary.main};
	margin-right: 30px;
	text-transform: capitalize;
	&.compare {
		text-transform: none;
	}
	&& span {
		* {
			display: inline-block;
		}
		@media (max-width: ${sizes.media.xSmallMaxWidth}px) {
			h1 {
				display: inline;
			}
		}
		${({ styles }) => styles}
	}
`;

export const CompareCruisesContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	padding: 20px 0;
	gap: 20px;

	@media (min-width: ${sizes.media.mediumMaxWidth}px) {
		flex-direction: row;
	}
`;

export const GoToCompareButton = styled(Button)`
	align-self: flex-end;
	text-wrap: nowrap;

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
      font-size: 13px !important;
    `,
		})[theme.brandCode]}
`;

export const CompareButtonsContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	align-self: stretch;
	gap: 10px;

	${GoToCompareButton} {
		width: 100%;
		order: -1;
	}

	@media (min-width: ${sizes.media.tabletMinWidth}px) {
		flex-direction: row;
		align-self: flex-end;

		${GoToCompareButton} {
			order: 0;
		}
	}
`;

export const CompareCloseButton = styled(Button)`
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
      text-transform: uppercase !important;
    `,
			[BrandCode.RoyalCaribbean]: `
      font-size: 16px !important;
      text-transform: capitalize !important;
      text-decoration: underline !important;
    `,
		})[theme.brandCode]}

	&:hover {
		background: unset !important;
		text-decoration: unset !important;
	}
`;
